import styled from '@emotion/styled'
import { Box } from '@mui/material'
import { getPxAsRem } from 'shared/utils'

export const StyledCard = styled.div`
    padding: ${getPxAsRem(20)};
    border-radius: ${getPxAsRem(8)};
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
    overflow: auto;
    height: ${getPxAsRem(500)};
    background-color: ${({ theme }) => theme.palette.greyscale.white};
`

export const Header = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${getPxAsRem(28)};
`
